import { useState } from 'react';
import { Typography } from '@kustom-checkout/morpheus';

import kustomLogo from '~/assets/kustom-logo.svg';
import shippingLogo from '~/assets/kss.svg';
import { SHIPPING_MODULE_VERSION } from '~/lib/version';

const REVEAL_AFTER_CLICKS = 3;

export function LogoWrapper() {
  const [clicks, setClicks] = useState(0);

  return (
    <div
      className="flex flex-row items-center gap-3"
      onClick={() => setClicks((count) => count + 1)}
    >
      <img src={shippingLogo} className="h-5" alt="KSS" />
      <img src={kustomLogo} width={93} height={28} alt="Kustom" />
      {clicks >= REVEAL_AFTER_CLICKS && (
        <Typography variant="xSmall" color="muted">
          Shipping module front-end version: {SHIPPING_MODULE_VERSION}
        </Typography>
      )}
    </div>
  );
}
